import { useMemo } from "react"
import { createQuery } from "@nova/queryable"
import { usePilotTrackingQuery } from "features/pilot-tracking/PilotTrackingQueries"

const DAY_MS = 24 * 3600 * 1000
const WARNING_DAYS = 14

const certificatesQuery = createQuery({
    resource: "user_certificates",
    select: ["id", "expires_at"],
})

export type CertificationCounts = {
    total: number
    current: number
    upcoming: number
    overdue: number
}

export const useCertificationCounts = (): { counts: CertificationCounts; isLoading: boolean } => {
    const { data, isLoading } = usePilotTrackingQuery(certificatesQuery)

    const counts = useMemo<CertificationCounts>(() => {
        if (!data) return { total: 0, current: 0, upcoming: 0, overdue: 0 }

        const now = Date.now()
        const warningCutoff = now + WARNING_DAYS * DAY_MS

        let current = 0
        let upcoming = 0
        let overdue = 0
        for (const c of data) {
            if (!c.expires_at) {
                current++
                continue
            }
            const expiresAt = new Date(c.expires_at).getTime()
            if (expiresAt < now) overdue++
            else if (expiresAt < warningCutoff) upcoming++
            else current++
        }

        return { total: data.length, current, upcoming, overdue }
    }, [data])

    return { counts, isLoading }
}
